export default {
  en: {
    user: {
      isFollowed: 'Following',
      follow: 'Follow',
      inGitflic: 'User {name} in Gitflic',
      verified: 'Verified'
    },
    users: {
      none: 'No users'
    }
  },
  ru: {
    user: {
      isFollowed: 'Вы подписаны',
      follow: 'Подписаться',
      inGitflic: 'Пользователь {name} в Gitflic',
      verified: 'Верифицирован'
    },
    users: {
      none: 'Нет пользователей'
    }
  }
};
